import { adminAxiosInstance } from "./axiosInstance";

export const getDailySpendings = async (): Promise<
  { _id: string; amountSum: number }[]
> => {
  return (await adminAxiosInstance.get("dashboard/dailySpendings")).data;
};
